"use strict";

import Page from "./ReferralCodes.jsx";

export const auth = true;
export const title = "i18n:referral.referralCodes";
export const Component = Page;
